import { rankingCommonConfig } from './common'
import type { RankingPageConfig } from './types'
import { resources as brandResources } from '@/config/brands'

export const theme = {
  rankGradient: 'linear-gradient(90deg, #13B866 0.03%, #8DDC6C 100%)',
  medalNumberTop: '-1px',
} as const

export const resources = {
  homeBg: '/images/florastory/home-bg.webp',
  spikeletL: '/images/florastory/ranking/spikelet_l.png',
  spikeletR: '/images/florastory/ranking/spikelet_r.png',
  goldMedal: brandResources.medals.goldMedal,
  silverMedal: brandResources.medals.silverMedal,
  bronze: brandResources.medals.bronze,
  medal: brandResources.medals.medal,
} as const

export const rankingConfig: RankingPageConfig = {
  theme,
  resources,
  texts: rankingCommonConfig.texts,
}
